<template>
  <div class="fun_container area_funcontents">
    <div class="container">
      <FuncSearchGallery/>
    </div>

    <div class="category">
      <div class="container">
        <CategoryTabs v-bind:selectedCategoryId="selectedCategoryId" />
        <CategoryContents v-bind:selectedCategoryId="selectedCategoryId" />
      </div>
    </div>
    <div class="row fun_top">
      <div class="col-lg-12">
        <p class="text-center">
          <FuncSearchGalleryTop>
            <LabelFunMessage fcontId="0" msgkey="14" />&nbsp;&raquo;
          </FuncSearchGalleryTop>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CategoryTabs from "../components/CategoryTabs";
import CategoryContents from "../components/CategoryContents";
import FuncSearchGallery from "../components/FuncSearchGallery";
import FuncSearchGalleryTop from "../components/FuncSearchGalleryTop";
import LabelFunMessage from "../components/LabelFunMessage";

export default {
  name: "Category",
  props: {
    categoryUrl: String,
  },
  components: {
    CategoryTabs,
    CategoryContents,
    FuncSearchGallery,
    FuncSearchGalleryTop,
    LabelFunMessage,
  },
  data() {
    return {
      descriptions: {
        1 : "0-142",
        2 : "0-143",
        3 : "0-145",
        4 : "0-144",
        5 : "0-146",
        6 : "0-147",
        7 : "0-148"
      },
    };
  },
  computed: {
    ...mapState(["categories"]),

    selectedCategoryId: function () {
      const category = this.$store.state.categories.find((category) => {
        return this.categoryUrl == category.title;
      });
      return category.id;
    },
    selectedCategoryLabel: function () {
      const category = this.$store.state.categories.find((category) => {
        return this.categoryUrl == category.title;
      });
      return category.label;
    },
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages[this.selectedCategoryLabel],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages[this.descriptions[this.selectedCategoryId]]}
      ],
      link: [{ rel: "stylesheet", href: process.env.VUE_APP_ROOT + "/assets/common/css/fun_top.css" }],
    };
  },
};
</script>

<style scoped>
.category {
  overflow: hidden;
  margin-bottom: 40px;
}
</style>